import { BreakpointsRender, CUSTOM_LAPTOP_WIDTH } from '../breakpointsRender';
import { BannerDesktop } from './banner.desktop';
import { BannerMobile } from './banner.mobile';

export interface BannerProps {
	isCollapsed?: boolean;
}

export const Banner = ({ isCollapsed }: BannerProps) => (
	<BreakpointsRender
		mobile={<BannerMobile isCollapsed={isCollapsed} />}
		laptop={<BannerDesktop />}
		customLaptopWidth={CUSTOM_LAPTOP_WIDTH}
	/>
);
